export default defineNuxtRouteMiddleware(() => {
  const { loggedIn, navigateToHome } = useAuth();

  if (loggedIn.value) {
    setTimeout(navigateToHome, 1);
  }
});
